export type { ExternalProps } from './bread-crumbs-dumb';
export { default as BreadCrumbsDumb } from './bread-crumbs-dumb';
